'use strict';

var _ = require('lodash');
var BaseLayer = require('./base/BaseLayer');

var MarkerLayer = BaseLayer.extend({

  _defaultStyleOptions: null,
  
  setStyle: function (style) {
    var options;

    // save the initial style as default so we can revert to it easily
    if (!this._defaultStyleOptions) {
      // get the previos marker options
      if (this.leafletLayer.options.icon) {
        if (this.leafletLayer.options.icon.getOptions) {
          options = this.leafletLayer.options.icon.getOptions();
        } else {
          options = this.leafletLayer.options.icon.options;
        }  
      }
      else {
        // for circle marker
        options = this.leafletLayer.options;
      }
      

      this._defaultStyleOptions = options;
    } else {
      options = this._defaultStyleOptions;
    }
    
    // set the updated style
    options = _.extend({}, options, style.iconOptions);

    // set the icon to the updated icon
    if (this.styles.getIcon) {
      var icon = this.styles.getIcon(options);
      this.leafletLayer.setIcon(icon);
    }

    if (style.opacity) {
      this.leafletLayer.setOpacity(style.opacity);
    }
  },

  _getPopupLatLng: function () {
    var leafletLayer = this.leafletLayer;
    return leafletLayer.getLatLng();
  },

  _getPopupOptions: function () {
    var offset = this.layer.data.properties && this.layer.data.properties.popupOffset;
    var classList = Array.prototype.slice.apply(this.leafletLayer._icon.classList);

    if (!offset) {
      var yOffset;

      if (classList.indexOf('shape-marker') !== -1) {
        yOffset = -1 * ((this.leafletLayer._icon.offsetHeight / 2));
      } else {
        yOffset = -1 * (this.leafletLayer._icon.offsetHeight);
      }

      offset = [0, yOffset];
    }

    var paddingTopLeft = L.point(60, 75);
    var paddingBottomRight = L.point(75, 60);

    return {
      closeButton: false,
      maxWidth: 300,
      offset: offset,
      className: 'layer-edit-dialog',
      autoPanPaddingTopLeft: paddingTopLeft,
      autoPanPaddingBottomRight: paddingBottomRight
    };
  },

  /**
   * Set leafletLayer style to highlighted
   */
  _setStateStyleToActive: function () {
    var style = this.styles.active;
    this.setStyle(style);
  },

  /**
   * Set leafletLayer style to its default
   */
  _setStateStyleToDefault: function () {
    var style = this.styles.default;
    this.setStyle(style);
  },

  /**
   * Set leafletLayer style to dimmed
   */
  _setStateStyleToDim: function () {
    var style = this.styles.dim;
    this.setStyle(style);
  },
});

module.exports = MarkerLayer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/MarkerLayer.js